<template>
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-10">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>
      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center items-center p-0">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-visible rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full max-w-lg sm:p-6"
            >
              <div>
                <div class="absolute top-3 right-3" v-if="showCloseButton">
                  <XMarkIcon
                    class="h-6 w-6 text-pdsPrimaryColor cursor-pointer"
                    aria-hidden="true"
                    @click.prevent="(open = false), $emit('close')"
                  />
                </div>

                <div class="mt-3 text-left sm:mt-5">
                  <div class="text-base font-semibold leading-6 text-gray-900 mx-4 my-2">
                    <slot name="header" />
                  </div>
                  <div class="justify-end mx-4 my-2">
                    <slot name="body" />
                  </div>
                </div>
              </div>
              <div class="my-4 sm:mt-6 grid grid-flow-row-dense gap-3 justify-end mx-4">
                <slot name="footer" />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { XMarkIcon } from '@heroicons/vue/20/solid';

const props = defineProps({
  modalOpenStatus: {
    type: Boolean,
    required: true,
    default: false
  },
  showCloseButton: {
    type: Boolean,
    required: false,
    default: false
  },
  show: {
    type: Boolean,
    required: false,
    default: false
  }
});
const open = ref(false);
watch(
  () => props.modalOpenStatus,
  (newVal) => {
    open.value = newVal;
  },
  { immediate: true }
);
</script>
